import { useState, useEffect, useLayoutEffect } from "react";

export function useProgressBar(ref) {
  const [scrollY, setScrollY] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);

  const setProgress = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight -
      footerHeight;
    const scrolled = (winScroll / height) * 100;
    ref.current.style.width = scrolled + "%";
  };

  useLayoutEffect(() => {
    const footer = document.querySelector("footer");
    const onResize = () => {
      setFooterHeight(footer.clientHeight);
    };

    setFooterHeight(footer.clientHeight);

    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [footerHeight]);

  useEffect(() => {
    const onScrollFunc = () => {
      setScrollY(() => window.scrollY);
      setProgress();
    };

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", onScrollFunc);
    }

    return () => {
      window.removeEventListener("scroll", onScrollFunc);
    };
  }, [scrollY]);
}
